import { Component, Input, OnInit, Optional, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl, Validators } from '@angular/forms';
import { IonInput } from '@ionic/angular';

@Component({
  selector: 'rfr-input-location',
  templateUrl: './rfr-input-location.component.html',
  styleUrls: ['./rfr-input-location.component.scss'],
})
export class RfrInputLocationComponent implements OnInit, ControlValueAccessor {
  @ViewChild("inputLocationElement", { static: false, read: IonInput }) inputLocationRef?: IonInput;
  @Input() id: string = ""
  @Input() type: string = 'text';
  @Input() alignInputText: 'center' | 'left' | 'right' = 'left';
  @Input() labelText: string = '';
  @Input() placeholder: string = '';
  @Input() pattern: string = '';
  @Input() required: boolean = false;
  @Input() readonly: boolean = false;
  @Input() error: boolean = false;
  @Input() errorMessage: string = '';
  @Input() min!: number;
  @Input() max!: number;
  @Input() maxLength: number = 250;
  @Input() class = "";
  @Input() style = "";
  @Input() size: 'normal' | 'large' = 'normal'; // Default value is 'normal'
  @Input() dotNumber: number = 2;
  @Input() iconName = '';

  displayValue: string = '';
  disabled!: boolean;
  onChange: (value: any) => void = () => { };
  onTouched: () => void = () => { };

  constructor (@Self() @Optional() public controlDir: NgControl) {
    if (this.controlDir) {
      this.controlDir.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    if (this.controlDir) {
      const control = this.controlDir.control;
      if (this.required && control) {
        const validators = control.validator
          ? [control.validator, Validators.required]
          : Validators.required;

        control.setValidators(validators);
        control.updateValueAndValidity();
      }
    }
  }

  getNativeInputLocation(): Promise<HTMLInputElement> {
    if (!this.inputLocationRef) {
      return Promise.reject('IonInput is not available');
    }

    return this.inputLocationRef.getInputElement();
  }

  writeValue(value: any): void {
    this.displayValue = value;
  }


  registerOnChange(onChange: (value: any) => void): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  onChangeInput(value: any): void {
    this.onChange(value);
    this.displayValue = value;
  }
}
